/**
 * LogRetentionService
 * Settings for the central log retention job (CCMS.Worker.ScheduledJobs > LogRetentionJob).
 * Admin only. Route: api/log-retention (CCMS.Api.System)
 */
import { BaseService } from '../base/BaseService';
export class LogRetentionService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LogRetentionService.DEFAULT_SERVICE_PATH,
            basePath: LogRetentionService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Every log table's policy with its last run. GET api/log-retention */
    async getLogRetentionPolicies() {
        const res = await this.http.get(this.buildUrl());
        return res?.data ?? [];
    }
    /** Saves a policy's settings. PUT api/log-retention/{policyId} */
    async updateLogRetentionPolicy(policyId, update) {
        const res = await this.http.put(this.buildUrl(String(policyId)), update);
        if (!res?.data)
            throw new Error(res?.message || `Failed to save log retention policy ${policyId}`);
        return res.data;
    }
    /**
     * Asks the cleaner to run this table now instead of waiting for the hourly pass (202).
     * The worker checks every minute; the request lapses after an hour.
     * POST api/log-retention/{policyId}/run-now
     */
    async runLogRetentionNow(policyId) {
        const res = await this.http.post(this.buildUrl(`${policyId}/run-now`));
        return res?.data ?? null;
    }
}
LogRetentionService.DEFAULT_SERVICE_PATH = 'system';
LogRetentionService.BASE_PATH = 'api/log-retention';
//# sourceMappingURL=LogRetentionService.js.map